// Avatar van een collega: de profielfoto uit Microsoft 365 over de initialen heen. Zonder foto (204) of zonder
// persoon blijven de initialen staan, ook terwijl de foto laadt.
import { useState } from "react";

// wie geen foto heeft: niet opnieuw vragen zolang de pagina openstaat
const missing = new Set<string>();

export function Av({ id, init, cls = "p-av", title }: { id?: string | null; init: string; cls?: string; title?: string }) {
  const [, redraw] = useState(0);
  const src = id && !missing.has(id) ? `/api/people/${id}/photo` : null;
  return (
    <span className={cls} title={title}>
      {init}
      {src && <img src={src} alt="" loading="lazy" onError={() => { missing.add(id!); redraw((n) => n + 1); }} />}
    </span>
  );
}
